export default __webpack_public_path__ + "static/media/avatar.2824ac73.jpg";